import React from 'react';
import { motion } from 'framer-motion';
import { Lock, AlertTriangle, Zap, FileText, ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
import { CountdownTimer } from './CountdownTimer';
export function OfferBlock() {
  const handleBuyClick = () => {
    trackAddToCart();
    window.location.href = 'https://clavedepaz.com/cart/44115100106851:1';
  };
  return <section id="offer" className="bg-navy py-24 px-6 border-y border-slate-800/50 relative overflow-hidden" data-id="element-181">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-5 pointer-events-none" data-id="element-182">
        <div className="absolute top-[20%] left-[50%] -translate-x-1/2 w-[80%] h-[80%] rounded-full bg-red-600 blur-[150px]" data-id="element-183"></div>
      </div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-184">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 md:p-12 rounded-2xl shadow-2xl shadow-red-900/20 border-2 border-red-100 relative" data-id="element-185">
          <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-6 py-1.5 rounded-full text-sm font-bold flex items-center gap-2 shadow-lg whitespace-nowrap" data-id="element-186">
            <span className="w-2 h-2 rounded-full bg-white animate-ping" data-id="element-187"></span>
            OFERTA POR TIEMPO LIMITADO
          </div>

          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-slate-900 mb-4 mt-4" data-id="element-188">
            Qué decirle a tu ex sin empeorar el conflicto (y sin afectar a tus
            hijos).
          </h2>

          <p className="text-lg text-slate-600 mb-6 max-w-xl mx-auto" data-id="element-189">
            Aprendé exactamente cómo responder en momentos difíciles, evitar
            discusiones innecesarias y mantener el control cuando más importa.
          </p>

          <div className="bg-slate-50 rounded-xl p-6 mb-8 border border-slate-100" data-id="element-190">
            <div className="text-sm font-bold text-red-600 uppercase tracking-wider mb-2 flex items-center justify-center gap-2" data-id="element-191">
              <AlertTriangle size={16} data-id="element-192" />
              La oferta termina pronto
            </div>

            <CountdownTimer data-id="element-193" />

            <p className="text-sm text-slate-500 font-medium mt-2" data-id="element-194">
              Cuando el contador llegue a 0, el precio vuelve a $23.998
            </p>
          </div>

          <div className="mb-10" data-id="element-195">
            <div className="flex flex-col items-center justify-center gap-1 mb-3" data-id="element-196">
              <div className="text-4xl md:text-5xl text-slate-400 line-through font-bold mb-1 decoration-red-500/50 decoration-4" data-id="element-197">
                Valor real: $23.998 ARS
              </div>
              <div className="text-6xl md:text-7xl font-bold text-green-600 font-sans leading-none flex items-center gap-3" data-id="element-198">
                <span className="text-3xl text-slate-600 font-medium" data-id="element-199">
                  Hoy:
                </span>{' '}
                $11.999 ARS
              </div>
            </div>
            <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-800 px-3 py-1 rounded-full text-sm font-bold mb-4 mt-2" data-id="element-200">
              <FileText size={14} data-id="element-201" />
              Formato PDF · Descarga inmediata · Acceso de por vida
            </div>
          </div>

          <button onClick={handleBuyClick} className="bg-green-600 hover:bg-green-700 text-white font-bold text-2xl md:text-3xl py-6 px-8 rounded-xl shadow-xl shadow-green-600/30 transition-all transform hover:scale-105 active:scale-95 w-full mb-4 border-b-4 border-green-800" data-id="element-202">
            COMPRAR AHORA (Acceso inmediato)
          </button>

          <p className="text-sm text-slate-500 mb-6 font-medium" data-id="element-203">
            Ebook digital (PDF). No es libro físico. Recibirás el acceso
            inmediatamente después del pago.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6 text-sm text-slate-600 font-medium" data-id="element-204">
            <div className="flex items-center justify-center gap-2 bg-slate-50 py-2 rounded-lg" data-id="element-205">
              <ShieldCheck size={16} className="text-green-600" data-id="element-206" />
              <span data-id="element-207">Pago 100% seguro</span>
            </div>
            <div className="flex items-center justify-center gap-2 bg-slate-50 py-2 rounded-lg" data-id="element-208">
              <Zap size={16} className="text-amber-500" data-id="element-209" />
              <span data-id="element-210">Acceso instantáneo</span>
            </div>
            <div className="flex items-center justify-center gap-2 bg-slate-50 py-2 rounded-lg" data-id="element-211">
              <FileText size={16} className="text-blue-500" data-id="element-212" />
              <span data-id="element-213">PDF descargable</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}